import type { Variant } from '@storefront/lib-global/codegen/types';

export const hasBackInStockFlag = (size: string, width: string, variants: Variant[]): boolean => {
  const filteredVariants = variants.filter(
    (variant) => (size ? variant.size === size : true) && (width ? variant.fitLabel === width : true),
  );

  // only return false if the flag is false; true/undefined should return true
  return filteredVariants.some((v) => v.backInStockNotificationsEnabled !== false);
};
